import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import style from './index.module.css'

// import required modules
import { Pagination } from 'swiper/modules';

export default function App() {
  return (
    <div className={style.header}>
      <Swiper
        pagination={{
          dynamicBullets: true,
        }}
        modules={[Pagination]}
        className={style.mySwiper}>
        <SwiperSlide>
          <div className={style.pr}>
            <div className={style.img1}>
                <img src='product-38.png'></img>
                <div className={style.from}>
                  <p>From</p>
                  <h4>$ 49.00</h4>
                </div>
                <div className={style.img2}>
                  <img src='product-39.png'></img>
                </div>
            </div>
            <div className={style.text}>
            <div className={style.hot}>
              <p>Hot Deal In This Week</p></div>
              <h1>Smart Digital Watch</h1>
              <a>Shop Now <i className="fa-solid fa-basket-shopping"></i></a>
            </div>
          </div>
          
           </SwiperSlide>
        <SwiperSlide> 
        <div className={style.pr}>
            <div className={style.img1}>
                <img src='product-39.png'></img>
                <div className={style.from}>
                  <p>From</p>
                  <h4>$ 49.00</h4>
                </div>
                <div className={style.img2}>
                  <img src='product-38.png'></img>
                </div>
            </div>
              <div className={style.text}>
                <div className={style.hot}>
                <p>Hot Deal In This Week</p>
                </div>
                 <h1>Roco Wirelles Headphone</h1>
                <a>Shop Now <i className="fa-solid fa-basket-shopping"></i></a>

            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
